import APITemplate from './APITemplate'

const url = '/odometer-correction'

const template = APITemplate(url)
export default {
  ...template,
  getActualOdometer (data) {
    return fetch('/odometer-correction/odometer', {
      method: 'PUT',
      credentials: 'include',
      redirect: 'error',
      headers: template.headers,
      body: JSON.stringify(data)
    }).then(template.saveHandler)
  },
  getHistoryOdometer (data) {
    return fetch('/odometer-correction/history-odometer', {
      method: 'PUT',
      credentials: 'include',
      redirect: 'error',
      headers: template.headers,
      body: JSON.stringify(data)
    }).then(template.saveHandler)
  }
}
